import { typeToDefaultValueMapping } from "@/constants";
import { AttributeValue } from "@/graphql";

export function convertJsonToString(value: AttributeValue) {
  if (typeof value === "string") {
    return value
      .trim()
      .replace(/[\r\n]+/g, " ")
      .replace(/\s+/g, " ");
  }

  return "";
}

export function convertStringToJson(value: AttributeValue) {
  if (typeof value === "string") {
    try {
      const parsedJson = JSON.parse(value);
      return JSON.stringify(parsedJson, null, 2);
    } catch (e) {
      return value;
    }
  }

  return value;
}

export function convertAttributeValue(oldValue: AttributeValue, oldType: string, newType: string): AttributeValue {
  if (newType === "string" && oldType === "json") {
    return convertJsonToString(oldValue);
  }

  if (newType === "json" && oldType === "string") {
    return convertStringToJson(oldValue);
  }

  return typeToDefaultValueMapping[newType];
}
